import { gql } from '@lcs/shared/api';

export const getExtensionGroupDetail = gql`
   query GetExtensionGroupDetail($id: UInt!) {
      extensionGroup(id: $id) {
         extensionGroupId
         description
         name
         account {
            accountId
            shortName
            name
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
         extensionGroupExtensionsConnection {
            items {
               extensionGroupExtensionId
               extension {
                  extensionId
                  number
                  name
                  type
               }
            }
         }
      }
   }
`;
